import { AppAlertService } from '../../services/app-alert/app-alert.service';
import { FormBuilder } from '@angular/forms';
import { PersonService } from '../../services/person/person.service';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonModal, ModalController } from '@ionic/angular';
import { Person, CIRCLE_NAMES } from 'src/app/models/person';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ActionSheetController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core/components';
import { ContactPayload, Contacts } from '@capacitor-community/contacts';
import { UserStore } from 'src/app/@auth/user.store';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'add-contact-page',
  templateUrl: './add-contact.component.html',
  styleUrls: ['./add-contact.component.scss'],
})
export class AddContactPage implements OnInit {

  showAddConnection = false;
  person: Person;
  pendingChanges = false;
  newChanges: Person;
  showBackdrop = false;
  contacts: ContactPayload[] | any[] = [];
  // contacts: ContactPayload[] | any[] = [{"contactId":"177C371E-701D-42F8-A03B-C61CA31627F6","phones":[{"number":"(555) 564-8583","type":"mobile"},{"number":"(415) 555-3695","type":"main"}],"emails":[{"address":"kate-bell@mac.com","type":"work"}],"birthday":{"month":1,"year":1978,"day":20},"name":{"given":"Kate","family":"Bell","prefix":"","display":"Kate Bell","suffix":"","middle":""},"circle":"close"},
  // {"name":{"family":"Appleseed","prefix":"","suffix":"","display":"John Appleseed","middle":"","given":"John"},"phones":[{"type":"mobile","number":"888-555-5512"},{"type":"home","number":"888-555-1212"}],"emails":[{"address":"John-Appleseed@mac.com","type":"work"}],"birthday":{"year":1980,"month":6,"day":22},"contactId":"410FE041-5C4E-48DA-B4DE-04C15EA3DBAC"}];
  contactsToAdd = [];
  unaddedContacts = {
    'close' : [],
    'inner' : [],
    'casual' : []
  };
  selectedStep: number = 0;
  contactsPermissionGranted = false; // Add this property

  constructor(
    private modalCtrl: ModalController,
    private modalService: ModalService,
    private personService: PersonService,
    private fb: FormBuilder,
    private actionSheetCtrl: ActionSheetController,
    private alertService: AppAlertService,
    private userStore: UserStore 
  ) { }

  async ngOnInit() {
    await this.checkContactsPermission();
    await this.getContacts();

    this.unaddedContacts['casual'] = this.contacts;
    this.unaddedContacts['close'] = this.contacts;
    this.unaddedContacts['inner'] = this.contacts;
  }

  async checkContactsPermission() {
    try {
      const grantedStatus = await Contacts.checkPermissions();
      return this.contactsPermissionGranted = grantedStatus.contacts  === 'granted';
    } catch (error) {
      console.error('Error checking contacts permission:', error);
      return false;
    }
  }

  async handleRefresh(event){
    event.target.complete();
  }

  dismiss() {
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }

  async changeCircle(selected=null) {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Select Circle',
      buttons: [
        {
          text: 'Inner Circle',
          role: selected == 'inner' ?  'selected' : null,
          data: {
            action: 'inner',
          },
        },
        {
          text: 'Close Circle',
          role: selected == 'close' ?  'selected' : null,
          data: {
            action: 'close',
          },
        },
        {
          text: 'Casual Circle',
          role: selected == 'casual' ?  'selected' : null,
          data: {
            action: 'casual',
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
          data: {
            action: 'cancel',
          },
        },
      ],
    });

    await actionSheet.present();

    let result = await actionSheet.onDidDismiss();
    let action = result.data.action;

    if (action != this.person.circle) {
      this.newChanges.circle = action;
      this.pendingChanges = true;
      this.person.circle = action;
      this.person.circleName = CIRCLE_NAMES[action];
    }
  }

  async changeContactPeriod(selected=null) {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Select Contact Period',
      buttons: [
        {
          text: 'Daily',
          role: selected == 'daily' ?  'selected' : null,
          data: {
            action: 'daily',
          },
        },
        {
          text: 'Weekly',
          role: selected == 'weekly' ?  'selected' : null,
          data: {
            action: 'weekly',
          },
        },
        {
          text: 'Bi-weekly',
          role: selected == 'bi-weekly' ?  'selected' : null,
          data: {
            action: 'bi-weekly',
          },
        },
        {
          text: 'Monthly',
          role: selected == 'monthly' ?  'selected' : null,
          data: {
            action: 'monthly',
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
          data: {
            action: 'cancel',
          },
        },
      ],
    });

    await actionSheet.present();

    let result = await actionSheet.onDidDismiss();
    let action = result.data.action;

    if (action != this.person.contactPeriod) {
      this.newChanges.contactPeriod = action;
      this.pendingChanges = true;
      this.person.contactPeriod = action;
    }
  }

  async changeDOB(event) {
    let action = event?.detail?.value;
    if (action != this.person.dob) {
      this.newChanges.dob = action;
      this.pendingChanges = true;
      this.person.dob = action;
    }
  }

  onDismissDateModal(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    if (ev.detail.role === 'confirm') {
      this.person.dob = new Date(ev.detail.data);
    }
  }

  async getContacts(recheckPermissions=false){
    if (Capacitor.getPlatform() === 'web') {
      console.log("platform:", Capacitor.getPlatform());
      this.alertService.showErrorAlert("Can't retrieve contacts", "bottom", 5000);
      return;
    }

    const contacts = await this.personService.retrieveListOfContacts(recheckPermissions);

    if (!contacts) {
      this.alertService.showErrorAlert("No contacts retrieved", "bottom", 5000);
      return;
    }
    // let contacts = this.contacts;
    console.log("recieved contacts", contacts);
    this.contacts = contacts
    this.unaddedContacts['casual'] = contacts;
    this.unaddedContacts['close'] = contacts;
    this.unaddedContacts['inner'] = contacts;

    return contacts;
  }

  onSelectionChange(contact, circle, isSelected) {
    if (isSelected.detail.checked) {
      contact.circle = circle;
      this.contactsToAdd.push(contact);
    } else {
      contact.circle = null;
      this.contactsToAdd = this.contactsToAdd.filter(c => c.contactId != contact.contactId);
    }

    for (let key in this.unaddedContacts) {
      let contactInList = this.unaddedContacts[key].find(c => c.contactId == contact.contactId);
      if (contactInList) {
        contactInList.circle = contact.circle;
      }
    }

    console.log(this.contactsToAdd, this.unaddedContacts);
  }

  onStepChange(event){
    this.selectedStep = event.index;
  }

  nextStep(){
    if (this.selectedStep < 2){
      this.selectedStep++;
    }
    else {
      this.saveContacts();
    }
  }

  async saveContacts(){
    let newPeople: Person[] | any[] = this.contactsToAdd.map(contact => {
      
      let formattedDOB = null;
      if (contact?.birthday) {
        formattedDOB = this.formatBirthday(contact);
      }
      
      return {
        firstName: contact?.name?.given,
        lastName: contact?.name?.family,
        emails: contact?.emails?.map(email => email?.address)?.[0],
        phones: contact?.phones?.map(phone => phone?.number)?.[0],
        circle: contact.circle,
        dob: formattedDOB,
        rawImportedContact: contact,
        user: this.userStore.getUser().documentId
      };
    });

    try {
      console.log(newPeople);
      await this.personService.bulkCreatePeople(newPeople);
      this.alertService.showSuccessAlert("Contacts Saved Successfully");
      this.modalCtrl.dismiss({
        'dismissed': true
      });
    } catch (e) {
      this.alertService.showErrorAlert("Failed to Save Contacts");
    }
  }

  formatBirthday(input: { birthday: { day: number, month: number, year: number } }): string {
    if (!input.birthday) {
      return null;
    }
    const { day, month, year } = input.birthday;
    const formattedMonth = String(month).padStart(2, '0');
    const formattedDay = String(day).padStart(2, '0');
    return `${year}-${formattedMonth}-${formattedDay}`;
  }
}
